import { useTranslation } from 'react-i18next';
import { Link, Typography, BluedolphinLogo, useTheme } from '@bluedolphin/ui';
import { CustomDivider } from '../../components/atoms/Divider';
import { CustomCard } from '../../components/atoms/Card';

/**
 * 404 page component
 *
 * @returns {JSX.Element}
 */
export default function NotFound() {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <div className="signup__wrapper">
            <BluedolphinLogo />
            <CustomCard
                elevation={1}
                sx={{
                    height: '198px',
                    borderColor: theme.palette.error.main,
                }}
            >
                <Typography
                    variant="h5"
                    sx={{ color: theme.palette.common.black }}
                >
                    {t('errors.title')}
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ color: theme.palette.error.main, marginTop: '12px' }}
                >
                    {t('errors.signUpDescription')}
                </Typography>
                <CustomDivider />
                <Typography
                    variant="body2"
                    sx={{ color: theme.palette.text.secondary }}
                >
                    {t('errors.text')}
                </Typography>
                <CustomDivider />
                <Link
                    href="mailto:support@valueblue.nl"
                    target="_blank"
                    underline="hover"
                >
                    <Typography
                        variant="body2"
                        sx={{ color: theme.palette.primary.main }}
                    >
                        {t('links.needLoginHelp')}
                    </Typography>
                </Link>
            </CustomCard>
        </div>
    );
}
